var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drag-handle",class:{ 
      'disabled': _vm.disabled,
      'horizontal': _vm.direction === 'horizontal',
      'vertical': _vm.direction === 'vertical'
    },on:{"mousedown":_vm.handleMouseDown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }